export let MIME_TYPES = {
    "doc": "application/msword",
    "docm": "application/vnd.ms-word.document.macroEnabled.12",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "pps": "application/vnd.ms-powerpoint",
    "ppsm": "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
    "ppsx": "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "ppt": "application/vnd.ms-powerpoint",
    "pptm": "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "jpe": "image/jpeg",
    "jpeg": "image/jpeg",
    "jpg": "image/jpeg",
    "png": "image/png",
    "pdf": "application/pdf",
    "gif": "image/gif",
    "zip": "application/zip",
    "rar": "application/x-rar-compressed",
    "mp4": "video/mp4",
    "mpg": "video/mpeg",
    "mov": "video/quicktime",
    "txt": "text/plain"
};


// WEBPACK FOOTER //
// ./src/model/MimeType.ts